export interface RidSessionData {
  resId: number;
  li: boolean;
  model: string;
  startDate: string;
  endDate: string;
  lang: string;
  num: string;
  pickupLoc: string;
  returnLoc: string;
  firstName: string;
  b2b: boolean;
  email: string;
  linkedNum: string;
  locationSearch: string;
  resCreateTime?: string;
  payMethod?: number;
  paymentMethod?: number;
  paymentProvider?: 'walley' | 'paytrail';
  cancelled?: boolean;
}

export function parseRidSession(raw: string | null | undefined): RidSessionData | undefined {
  if (!raw) return undefined;
  try {
    return JSON.parse(raw) as RidSessionData;
  } catch {
    return undefined;
  }
}
